module.exports = __webpack_public_path__ + "media/images/guide-thumb-3t-aa263ed6aa1b62468fa273cfdccb6e7b.png";